import { render, staticRenderFns } from "./InfoPlan.vue?vue&type=template&id=453c0c08&scoped=true&"
import script from "./InfoPlan.vue?vue&type=script&lang=js&"
export * from "./InfoPlan.vue?vue&type=script&lang=js&"
import style0 from "./InfoPlan.vue?vue&type=style&index=0&id=453c0c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c0c08",
  null
  
)

export default component.exports